import { Table } from 'react-bootstrap';

export function DataTable({ headers, rows, className = "" }) {
  return (
    <Table hover className={`mb-0 align-middle ${className}`}>
      <thead>
        <tr>
          {headers.map((header) => <th key={header}>{header}</th>)}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, index) => (
          <tr key={`${row[0]}-${index}`}>
            {row.map((cell, cellIndex) => <td key={`${headers[cellIndex]}-${cellIndex}`}>{cell}</td>)}
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
